var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "InputText",
      class: _vm.hasChanged
        ? _vm.isCorrect
          ? "InputText--valid"
          : "InputText--error"
        : ""
    },
    [
      _c("div", { staticClass: "InputText-container" }, [
        _c(
          "div",
          { staticClass: "Form-row" },
          [
            _c("input", {
              staticClass: "InputText-input Form-input",
              class: {
                "InputText-input--valid": _vm.hasChanged && _vm.isCorrect,
                "InputText-input--error": _vm.hasChanged && !_vm.isCorrect,
                hasValue: this.inputValue.length
              },
              attrs: {
                type: "text",
                name: "InputText-" + _vm.answer.id,
                id: "InputText-" + _vm.answer.id,
                required: _vm.answer.required
              },
              on: { keyup: _vm.isCorrectValue }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "Form-label",
                attrs: { for: "InputText-" + _vm.answer.id }
              },
              [_vm._v(_vm._s(this.answerLabel))]
            ),
            _vm._v(" "),
            _c("FormInputIcon", { attrs: { isLoading: false } })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "InputText-message" }, [
          _vm._v(
            "Ce champs de formulaire Ne peut contenir que du texte. et ne peut pas être vide"
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }